import create from 'zustand';

const initialCategoryState = {
  selectedSubCategoryUID: '',
  selectedCategoryUID: ''
};

const initialBreadcrumbState = {
  primeBreadcrumbs: []
};

const usePrimeHomeStore = create((set) => ({
  ...initialCategoryState,
  ...initialBreadcrumbState,
  setSelectedPrimeCategory: ({
    selectedSubCategoryUID = '',
    selectedCategoryUID = ''
  }) =>
    set({
      selectedSubCategoryUID,
      selectedCategoryUID
    }),
  setPrimeBreadcrumbs: (primeBreadcrumbs = []) =>
    set({
      primeBreadcrumbs
    }),
  resetSelectedPrimeCategory: () => set(initialCategoryState)
}));

export default usePrimeHomeStore;
